import React from "react";
import Slider from '@mui/material/Slider'
import { Grid } from "@material-ui/core"
import Hidden from '@mui/material/Hidden';

import { Range } from "../../../../plas/map/places/models";

export default function RangeView({ range, otherRanges, onChange, disable }) {

  let newRange = new Range()

  const [value, setValue] = React.useState([range.startTime.toMinutes(), range.endTime.toMinutes()]);

  React.useEffect(() => {
    setValue([range.startTime.toMinutes(), range.endTime.toMinutes()])
  }, [range]);

  const handleChange = (event, newValue) => {

    let nextValue = newValue
    if (value[0] === 0 && value[1] === 0) {
      nextValue = [newValue[1],newValue[1]]
    }
    var conflict = false

    newRange.startTime.fromMinutes(nextValue[0]);
    newRange.endTime.fromMinutes(nextValue[1]);

    otherRanges.forEach((auxRange) => {
      if (newRange.intersects(auxRange)) {
        conflict = true
      }
    })

    if (!conflict) {
      range.startTime = newRange.startTime
      range.endTime = newRange.endTime
      setValue(nextValue)
      onChange(range)
    }

  };


  const valueText = (value) => {
    let hour = Math.trunc(value / 60)
    let minutes  = value - (hour*60)

    let hourText = (hour > 9) ? hour.toString() : "0" + hour.toString();
    let minutesText = (minutes > 9) ? minutes.toString() : "0" + minutes.toString();

    return hourText + ":" + minutesText;
  }


  return (
    <Grid container spacing={2} >

      <Grid item xs={'auto'} style={{ paddingRight: '36px'}}> 
        <span style={{ display: 'inline-block', minWidth: '45px'}}>
          {valueText(range.startTime.toMinutes())}
        </span>
        <br/>
        <span style={{ display: 'inline-block', minWidth: '45px'}}>
          {valueText(range.endTime.toMinutes())}
        </span>
      </Grid>

      <Grid item xs={true}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <Slider
              value={value}
              disabled={disable}
              onChange={handleChange}
              min={0}
              max={1440}
              step={5}
              valueLabelDisplay="auto"
              valueLabelFormat={valueText} />
          </Grid>
          <Grid item xs={12} style={{marginTop: '-12px'}}>
            <Grid container spacing={0}>
              <Grid item xs={1} style={{textAlign: 'left'}} > 
                <span style={{marginLeft: '-14px', fontSize: '15px'}}>0:00</span>
              </Grid>
              <Grid item xs={1} style={{textAlign: 'center'}} > 
                <Hidden implementation="css" smDown>
                  <span style={{fontSize: '15px'}}>3:00</span>
                </Hidden>
              </Grid>
              <Grid item xs={2} style={{textAlign: 'center'}} > 
                <span style={{fontSize: '15px'}}>6:00</span>
              </Grid>
              <Grid item xs={1} style={{textAlign: 'center'}} > 
                <Hidden implementation="css" smDown>
                  <span style={{fontSize: '15px'}}>9:00</span>
                </Hidden>
              </Grid>
              <Grid item xs={2} style={{textAlign: 'center'}} > 
                <span style={{fontSize: '15px'}}>12:00</span>
              </Grid>
              <Grid item xs={1} style={{textAlign: 'center'}} > 
                <Hidden implementation="css" smDown>
                  <span style={{fontSize: '15px'}}>15:00</span>
                </Hidden>
              </Grid>
              <Grid item xs={2} style={{textAlign: 'center'}} > 
                <span style={{fontSize: '15px'}}>18:00</span>
              </Grid>
              <Grid item xs={1} style={{textAlign: 'center'}} > 
                <Hidden implementation="css" smDown>
                  <span style={{fontSize: '15px'}}>21:00</span>
                </Hidden>
              </Grid>
              <Grid item xs={1} style={{textAlign: 'right'}} >
                <span style={{marginRight: '-20px', fontSize: '15px'}}>24:00</span>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      
    </Grid>
  );
}
